// src/signals/basic-filter-signal.ts
function _assert_this_initialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _class_call_check(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _get_prototype_of(o) {
  _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
  if (call && (_type_of(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
  _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _set_prototype_of(o, p);
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _type_of(obj) {
  "@swc/helpers - typeof";

  return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _create_super(Derived) {
  var hasNativeReflectConstruct = _is_native_reflect_construct();
  return function _createSuperInternal() {
    var Super = _get_prototype_of(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _get_prototype_of(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possible_constructor_return(this, result);
  };
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment SortAndFilterBasicFilterPayloadFragment on SortAndFilterBasicFilterPayload {\n    filterId\n    type\n  }\n\n  fragment SortAndFilterSelectedFilterPillPayloadFragment on SortAndFilterSelectedFilterPillPayload {\n    deselectionSignalId\n    filter {\n      ... on EGDSBasicRemovablePill {\n        name\n        accessibility\n        id\n        removeAnalytics {\n          eventType\n          linkName\n          referrerId\n          uisPrimeMessages {\n            schemaName\n            messageContent\n          }\n        }\n      }\n    }\n    filterName {\n      ... on EGDSPlainText {\n        text\n      }\n      ... on EGDSBasicLocalizedText {\n        template\n        models {\n          key\n          source\n        }\n      }\n    }\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
import { Signal } from "@shared-ui/core-signal-manager/spi";
var SortAndFilterBasicFilterSignal = /*#__PURE__*/function (Signal) {
  "use strict";

  _inherits(SortAndFilterBasicFilterSignal, Signal);
  var _super = _create_super(SortAndFilterBasicFilterSignal);
  function SortAndFilterBasicFilterSignal() {
    _class_call_check(this, SortAndFilterBasicFilterSignal);
    return _super.apply(this, arguments);
  }
  return SortAndFilterBasicFilterSignal;
}(Signal);
// src/signals/selected-filter-pill-signal.ts
import { Signal as Signal2 } from "@shared-ui/core-signal-manager/spi";
var SortAndFilterSelectedFilterPillSignal = /*#__PURE__*/function (Signal2) {
  "use strict";

  _inherits(SortAndFilterSelectedFilterPillSignal, Signal2);
  var _super = _create_super(SortAndFilterSelectedFilterPillSignal);
  function SortAndFilterSelectedFilterPillSignal() {
    _class_call_check(this, SortAndFilterSelectedFilterPillSignal);
    return _super.apply(this, arguments);
  }
  return SortAndFilterSelectedFilterPillSignal;
}(Signal2);
// src/signals/fragments.ts
import { gql } from "@apollo/client";
var SortAndFilterSignalPayloadFragment = gql(_templateObject());
export { SortAndFilterBasicFilterSignal, SortAndFilterSelectedFilterPillSignal, SortAndFilterSignalPayloadFragment };